export const PacAccountTypes = ['Post-Acute Facility', 'Hospital CM/Discharge Planner'];
export const DualAccountTypes = ['Health Plan Case Manager', 'Physician', 'Hospital CM/Discharge Planner'];
